import React from 'react'
import { extend } from '@react-three/fiber'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import helvetiker from 'three/examples/fonts/helvetiker_regular.typeface.json'
import { Cube } from '../geometries/Cube'
import { degreesToRadians } from '../helpers'

export const TextItem = ({ position = [0, 0, 0], rotation = 0, text = 'text', height = 10, width = 10, color = 'lime', hideShadow = false }) => {
	extend({ TextGeometry })
	const helvetikerRegular = new FontLoader().parse(helvetiker)

	const textOptions = {
		font: helvetikerRegular,
		size: width,
		height,
	  }

	return (
		<group castShadow={!hideShadow} position={position} rotation={[0, degreesToRadians(rotation) * -1, 0]}>
			<Cube color='red' />
			<mesh position={[width / 2, 0, height * -1]} rotation={[Math.PI / -2, 0, Math.PI]} castShadow receiveShadow>
				<textGeometry attach='geometry' args={[text, textOptions]}/>
				<meshStandardMaterial color={color} />
			</mesh>
		</group>
	)
}
